import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/demand-planning/fashion/")({
  loader: ({ location }) => {
    if (location.pathname === "/demand-planning/fashion") {
      throw redirect({
        to: "/demand-planning/fashion/timeline",
      })
    }
    return null
  },
})
